<template>
  <section class="mod-detail-outline">
    <div class="mod-image-holder">
      <preview-job-picture
        :photo-id="mainPhotoId"
        :alt="jobName"
        v-on="$listeners"
      />
    </div>
    <div class="mod-detail-tag">
      <ul class="mod-detail-tag-inner">
        <li
          v-for="(prIcon,i) in firstPrIcons"
          :key="i"
        >
          <span
            :class="prIcon.class"
            :data-test="`first-pr-icon-${i}`"
            v-text="prIcon.name"
          />
        </li>
      </ul>
      <ul class="mod-detail-tag-inner">
        <li
          v-for="(prIcon,i) in secondPrIcons"
          :key="i"
        >
          <span
            :class="prIcon.class"
            :data-test="`second-pr-icon-${i}`"
            v-text="prIcon.name"
          />
        </li>
      </ul>
    </div>
    <div class="mod-detail-text">
      <h2
        class="caption pega-pre-wrap"
        data-test="main-title"
        v-text="mainTitle"
      />
      <p
        class="sub-caption pega-pre-wrap"
        data-test="body-first-line"
        v-text="bodyFirstLine"
      />
      <template v-if="showToggle">
        <transition
          name="trans-slide"
          @before-enter="resetHeight"
          @enter="setHeight"
          @after-enter="emitToggle"
          @before-leave="setHeight"
          @leave="resetHeight"
          @after-leave="emitToggle"
        >
          <p
            v-if="isOpenMainBody"
            class="sub-caption pega-pre-wrap"
            data-test="body-other-line"
            v-text="bodyOtherLine"
          />
        </transition>
        <div
          v-if="!isOpenMainBody"
          class="mod-detail-text-btn pega-input"
          data-test="open-toggle-button"
          @click="toggleMainBody()"
        >
          <p class="text">
            <span class="arrow down" /><span>続きを読む</span>
          </p>
        </div>
        <div
          v-else-if="isOpenMainBody"
          class="mod-detail-text-btn pega-input"
          data-test="close-toggle-button"
          @click="toggleMainBody()"
        >
          <p class="text">
            <span class="arrow down close-sub-caption" /><span>閉じる</span>
          </p>
        </div>
      </template>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;

.trans-slide-enter-active, .trans-slide-leave-active {
  transition: all 0.5s;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import PreviewJobPicture from '@/components/atoms/PreviewJobPicture'
import _ from 'lodash'

export default {
  components: {
    PreviewJobPicture
  },
  props: {
    mainPhotoId: {
      type: Number,
      default: 0
    },
    jobName: {
      type: String,
      required: true
    },
    jobPrIcons: {
      type: Array,
      default: () => []
    },
    mainTitle: {
      type: String,
      required: true
    },
    mainBody: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      prIconMaps: [],
      isOpenMainBody: true
    }
  },
  computed: {
    ...mapGetters({
      prIcon: 'prIconDisplayMaster'
    }),
    firstPrIcons () {
      return this.prIconMaps.slice(0, 5)
    },
    secondPrIcons () {
      return this.prIconMaps.slice(5, 10)
    },
    bodyFirstLine () {
      return _.head(this.mainBody.split('\n'))
    },
    bodyOtherLine () {
      return _.drop(this.mainBody.split('\n')).join('\n')
    },
    showToggle () {
      return !!this.bodyOtherLine
    }
  },
  created () {
    this.storeMaster('prIconDisplay')
    this.createPrIconMaps()
  },
  mounted () {
    this.setToggleData()
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    createPrIconMaps () {
      this.$set(this, 'prIconMaps',
        this.prIcon
        // 「上場企業(id:13)」と「転勤なし(id:17)」はスマホ版では表示しないので省く
          .filter(i => i.id !== 13 && i.id !== 17)
          .map(i => {
            return {
              id: i.id,
              name: i.name,
              class: this.jobPrIcons.includes(i.id) ? 'on' : 'off'
            }
          })
      )
    },
    setToggleData () {
      // 開閉処理用の情報取得
      this.$set(this, 'isOpenMainBody', false)
    },
    toggleMainBody () {
      this.$set(this, 'isOpenMainBody', !this.isOpenMainBody)
    },
    emitToggle () {
      this.$emit('toggle')
    },
    resetHeight (el) {
      el.style.height = 0
    },
    setHeight (el) {
      el.style.height = el.scrollHeight + 'px'
    }
  }
}
</script>
